<template>
  <modal title="Общее описание операций" @backdrop-click="closeModal">
    <template slot="body">
      <div>
        <div
          v-if="!hasDefaultValue"
          class="body__action_default-value"
          @click="returnDefaultValue"
        >
          <span>
            Вернуть стандартное значение
          </span>
        </div>
        <input
          maxlength="50"
          class="form-control"
          v-model="description"
        />
      </div>
    </template>
    <template slot="footer">
      <div class="modal__buttons">
        <div>
          <button
            class="modal-default-button btn btn-danger close-btn buttons__button_close-modal"
            @click="closeModal"
          >
            Закрыть
          </button>
        </div>
        <div>
          <button
            class="modal-default-button btn btn-success left-btn"
            :disabled="!description"
            @click="save"
          >
            Выбрать
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/_shared/components/ui/Modal";
import store from "@/stock/store";
export default {
  emits: ["close"],
  components: {
    Modal,
  },
  data() {
    return {
      description: '',
    };
  },
  mounted() {
    document.querySelector("body").style.overflow = "hidden";
    this.description = JSON.parse(JSON.stringify(
      store.state.newOperations.generalDescription
    ));
  },
  computed: {
    hasDefaultValue() {
      return !!(this.description === 'Ручная операция');
    },
  },
  methods: {
    returnDefaultValue() {
      this.description = 'Ручная операция';
    },
    save() {
      const storeAction = 'newOperations/setGeneralDescription';
      store.dispatch(storeAction, this.description);
      this.closeModal();
    },
    closeModal() {
      this.$emit("close");
    }
  }
};
</script>

<style scoped>
.body__action_default-value {
  animation: vertical-appear 0.5s;
  font-size: 0.8em;
  color: #428bca;
  margin-bottom: 1.2em;
}
.body__action_default-value:hover {
  cursor: pointer;
  opacity: 0.5;
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// src/stock/widgets/new-operations/GeneralDescriptionModal.vue